<template>
	<div>
		<!-- <input type="image" style="width: 300px; height: 300px;" src="https://tpa-system.oss-cn-shanghai.aliyuncs.com/userImage/1111.jpg" /> -->
		<h1 style="margin-top: 80px; text-align: center">{{ $t('login.login_title') }}</h1>
		<el-form  v-loading="loading" element-loading-text="Login" :rules="rules" :model="loginForm" class="loginContainer" ref="loginForm">
			
			<h3 class="loginTitle">{{ $t('login.login_welcome') }}</h3>
			<el-form-item prop="username">
				
				<el-input type="text" v-model="loginForm.username" 
				auto-complete="off" :placeholder="this.$t('login.username')" @keydown.enter.native="submitLogin"></el-input>
			</el-form-item>
			<el-form-item prop="password">
				
				<el-input type="text" v-model="loginForm.password" show-password
				auto-complete="off" :placeholder="this.$t('login.password')" @keydown.enter.native="submitLogin"></el-input>
			</el-form-item>
			<center>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="text"></el-button>
				<el-button type="primary" style="width: 50%" @click="submitLogin">{{$t('login.login')}}</el-button>
				<el-button @click="lang_zh" type="text">中文</el-button>
				<el-button @click="lang_en" type="text">English</el-button>
			</center>
		</el-form>

	</div>
</template>

<script>
	export default {
		name: 'Login',
		components: {

		},
		data() {
			return {
				loginForm: {
					username: '',
					password: ''
				},
				rules: {
					username: [{required:true, message:'请输入用户名', trigger: 'blur'}],
					password: [{required:true, message:'请输入密码', trigger: 'blur'}]
				},
				loading: false
			};
		},
		created:function(){
			let userInfo = window.localStorage.getItem("user");

			if(userInfo !== null){
				// 页面跳转Home页 replace是替换不能回退，push页面可以回退
				this.$router.replace('/home');
			}
      else{
        this.$router.replace('/');
        console.log("login fail");
      }
		},
		methods: {
			lang_zh(){
				this.$i18n.locale = 'zh'
				console.log(this.$i18n.locale)
			},
			lang_en(){
				this.$i18n.locale = 'en'
				console.log(this.$i18n.locale)
			},
			submitLogin(){
				// 表单校验固定格式
				this.loading = true;
				this.$refs.loginForm.validate((valid) => {
					if(valid){
						//发送post请求
						this.postRequest('/tpa-api/admin/login',this.loginForm).then(resp=>{
							if(resp){
								this.loading = true;
								// JSON转换换成字符串保存
								window.localStorage.setItem("token",resp.result.token);
								window.localStorage.setItem("user",JSON.stringify(resp.result));
								// 页面跳转Home页 replace是替换不能回退，push页面可以回退
								this.$router.replace('/home');
							}
							this.loading = false;
						});
					} else {
            this.loading = false;
            this.$message.error('请输入所有字段');
						return false;
					}
				});
			}
		},
	};
</script>

<style>
	.loginContainer {
	  width: 420px;
	  margin: 80px auto;
	  border: #dcdfe6 solid 1px;
	  padding: 30px 40px 20px 20px;
	  border-radius: 20px;
	  display: flex;
	  flex-direction: column;
	}
	.loginTitle {
	  text-align: center;
	  margin-bottom: 30px;
	}
	
</style>
